import { selectBanner } from './selectBanner';
import { IApplicationState } from '../../types/redux';

export const selectBannerPopup = (state: IApplicationState) => {
  const banner = selectBanner(state);

  return banner && banner.popup;
};
